import React from "react";
import styles from "./progress-overlay.module.scss";
import { Progress  } from "@ceridianhcm/components";

const ProgressOverlay: React.FC<{
    message: string,
    visible?: boolean|null,
    testId?:string
}> = ({
    message,
    visible,
    testId
}) => {
    return (
        <div className={`${styles.modal} ${(visible ? styles.is_active : '')}`}  data-testid={testId}>
            <div className="overlay_message_container">
                <div className={styles.modal_background}></div>
                <div className={`${styles.modal_content} ${styles.progress_container}`}>
                    <Progress indeterminate label={message}/>
                </div>
            </div>
        </div>
    );
};

export { ProgressOverlay }